<template>
  <br />
  <div class="col-sm-12">

    <div v-if="loading && !form.informacionPersonal.nombre" class="text-center py-4">
      <small>Cargando datos...</small>
    </div>

    <div v-if="error" class="alert alert-danger">{{ error }}</div>
    <div v-if="successMsg" class="alert alert-success">{{ successMsg }}</div>

    <form class="card detalle-contratante" @submit.prevent="save" v-if="!loading || form.informacionPersonal.nombre">
      <div class="card-header d-flex justify-content-between align-items-center">
        <h5 class="mb-0">Editar Contratante</h5>
        <button type="button" class="btn btn-sm btn-secondary" @click="$router.back()">
          <vue-feather type="arrow-left" size="14" class="me-1" /> Regresar
        </button>
      </div>

      <div class="card-body">

        <!-- Información Personal -->
        <section>
          <h6 class="section-title"><vue-feather type="user" size="14" class="me-1" /> Información Personal</h6>
          <div class="row g-3">
            <div class="col-6 col-md-3">
              <label class="form-label">Nombre <span class="text-danger">*</span></label>
              <input v-model="form.informacionPersonal.nombre" type="text" class="form-control form-control-sm" required />
            </div>
            <div class="col-6 col-md-3">
              <label class="form-label">Apellido Paterno <span class="text-danger">*</span></label>
              <input v-model="form.informacionPersonal.paterno" type="text" class="form-control form-control-sm" required />
            </div>
            <div class="col-6 col-md-3">
              <label class="form-label">Apellido Materno</label>
              <input v-model="form.informacionPersonal.materno" type="text" class="form-control form-control-sm" />
            </div>
            <div class="col-6 col-md-3">
              <label class="form-label">RFC</label>
              <input v-model="form.informacionPersonal.rfc" type="text" class="form-control form-control-sm" maxlength="13" />
            </div>
            <div class="col-6 col-md-3">
              <label class="form-label">Género</label>
              <select v-model="form.informacionPersonal.generoId" class="form-select form-select-sm">
                <option :value="null">— Seleccionar —</option>
                <option v-for="g in catalogos.generos" :key="g.id" :value="g.id">{{ g.nombre }}</option>
              </select>
            </div>
            <div class="col-6 col-md-3">
              <label class="form-label">Estado Civil</label>
              <select v-model="form.informacionPersonal.estadoCivilId" class="form-select form-select-sm">
                <option :value="null">— Seleccionar —</option>
                <option v-for="e in catalogos.estadosCiviles" :key="e.id" :value="e.id">{{ e.nombre }}</option>
              </select>
            </div>
            <div class="col-6 col-md-3">
              <label class="form-label">Estatura (m)</label>
              <input v-model.number="form.informacionPersonal.estatura" type="number" step="0.01" min="0" max="3" class="form-control form-control-sm" />
            </div>
            <div class="col-6 col-md-3">
              <label class="form-label">Peso (kg)</label>
              <input v-model.number="form.informacionPersonal.peso" type="number" step="0.1" min="0" class="form-control form-control-sm" />
            </div>
          </div>
        </section>

        <!-- Información Laboral -->
        <section>
          <h6 class="section-title"><vue-feather type="briefcase" size="14" class="me-1" /> Información Laboral</h6>
          <div class="row g-3">
            <div class="col-6 col-md-3">
              <label class="form-label">Unidad</label>
              <select v-model="form.informacionLaboral.unidadId" class="form-select form-select-sm">
                <option :value="null">— Seleccionar —</option>
                <option v-for="u in catalogos.unidades" :key="u.id" :value="u.id">{{ u.nombre }}</option>
              </select>
            </div>
            <div class="col-6 col-md-3">
              <label class="form-label">Puesto</label>
              <input v-model="form.informacionLaboral.puesto" type="text" class="form-control form-control-sm" />
            </div>
            <div class="col-6 col-md-3">
              <label class="form-label">Área</label>
              <input v-model="form.informacionLaboral.area" type="text" class="form-control form-control-sm" />
            </div>
            <div class="col-6 col-md-3">
              <label class="form-label">Departamento</label>
              <input v-model="form.informacionLaboral.departamento" type="text" class="form-control form-control-sm" />
            </div>
            <div class="col-6 col-md-3">
              <label class="form-label">Fecha de Ingreso</label>
              <input v-model="form.informacionLaboral.fechaIngreso" type="date" class="form-control form-control-sm" />
            </div>
            <div class="col-6 col-md-3">
              <label class="form-label">Referencias</label>
              <input v-model="form.informacionLaboral.referencias" type="text" class="form-control form-control-sm" />
            </div>
          </div>
        </section>

        <!-- Domicilios -->
        <section>
          <div class="d-flex justify-content-between align-items-center">
            <h6 class="section-title mb-0"><vue-feather type="home" size="14" class="me-1" /> Domicilios</h6>
            <button type="button" class="btn btn-xs btn-outline-primary" @click="addDomicilio">
              <vue-feather type="plus" size="14" /> Agregar
            </button>
          </div>
          <p v-if="form.domicilios.length === 0" class="text-muted small mb-0 mt-2">Sin domicilios registrados.</p>
          <div class="entry-list mt-2" v-else>
            <div v-for="(dom, idx) in form.domicilios" :key="idx" class="item-card">
              <div class="d-flex justify-content-between align-items-center mb-2">
                <strong class="small">Domicilio {{ idx + 1 }}</strong>
                <button type="button" class="btn btn-xs btn-outline-danger" @click="removeDomicilio(idx)">
                  <vue-feather type="trash-2" size="14" />
                </button>
              </div>
              <div class="row g-2">
                <div class="col-6 col-md-4">
                  <label class="form-label">Tipo de Domicilio</label>
                  <select v-model="dom.tipoDomicilioId" class="form-select form-select-sm">
                    <option :value="null">— Seleccionar —</option>
                    <option v-for="t in catalogos.tiposDomicilio" :key="t.id" :value="t.id">{{ t.nombre }}</option>
                  </select>
                </div>
                <div class="col-6 col-md-4">
                  <label class="form-label">Calle</label>
                  <input v-model="dom.calle" type="text" class="form-control form-control-sm" />
                </div>
                <div class="col-6 col-md-3">
                  <label class="form-label">Estado</label>
                  <select v-model="dom.estadoId" class="form-select form-select-sm">
                    <option :value="null">— Seleccionar —</option>
                    <option v-for="e in catalogos.estados" :key="e.id" :value="e.id">{{ e.nombre }}</option>
                  </select>
                </div>
                <div class="col-6 col-md-1 d-flex align-items-end">
                  <div class="form-check">
                    <input type="checkbox" v-model="dom.isActive" class="form-check-input" :id="'dom-active-' + idx" />
                    <label class="form-check-label small" :for="'dom-active-' + idx">Activo</label>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <!-- Medios de Contacto -->
        <section>
          <div class="d-flex justify-content-between align-items-center">
            <h6 class="section-title mb-0"><vue-feather type="mail" size="14" class="me-1" /> Medios de Contacto</h6>
            <button type="button" class="btn btn-xs btn-outline-primary" @click="addMedio">
              <vue-feather type="plus" size="14" /> Agregar
            </button>
          </div>
          <p v-if="form.medios.length === 0" class="text-muted small mb-0 mt-2">Sin medios de contacto.</p>
          <div class="entry-list mt-2" v-else>
            <div v-for="(medio, idx) in form.medios" :key="idx" class="item-card">
              <div class="d-flex justify-content-between align-items-center mb-2">
                <strong class="small">Medio {{ idx + 1 }}</strong>
                <button type="button" class="btn btn-xs btn-outline-danger" @click="removeMedio(idx)">
                  <vue-feather type="trash-2" size="14" />
                </button>
              </div>
              <div class="row g-2">
                <div class="col-6 col-md-4">
                  <label class="form-label">Tipo de Medio</label>
                  <select v-model="medio.tipoMedioId" class="form-select form-select-sm">
                    <option :value="null">— Seleccionar —</option>
                    <option v-for="t in catalogos.tiposMedio" :key="t.id" :value="t.id">{{ t.nombre }}</option>
                  </select>
                </div>
                <div class="col-6 col-md-6">
                  <label class="form-label">Descripción / Valor</label>
                  <input v-model="medio.descripcion" type="text" class="form-control form-control-sm" />
                </div>
                <div class="col-6 col-md-2 d-flex align-items-end">
                  <div class="form-check">
                    <input type="checkbox" v-model="medio.isActive" class="form-check-input" :id="'medio-active-' + idx" />
                    <label class="form-check-label small" :for="'medio-active-' + idx">Activo</label>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <!-- Información Financiera -->
        <section class="last">
          <div class="d-flex justify-content-between align-items-center">
            <h6 class="section-title mb-0"><vue-feather type="dollar-sign" size="14" class="me-1" /> Información Financiera</h6>
            <button type="button" class="btn btn-xs btn-outline-primary" @click="addFinanciero">
              <vue-feather type="plus" size="14" /> Agregar
            </button>
          </div>
          <p v-if="form.informacionFinanciera.length === 0" class="text-muted small mb-0 mt-2">Sin información financiera.</p>
          <div class="entry-list mt-2" v-else>
            <div v-for="(fin, idx) in form.informacionFinanciera" :key="idx" class="item-card">
              <div class="d-flex justify-content-between align-items-center mb-2">
                <strong class="small">Cuenta {{ idx + 1 }}</strong>
                <button type="button" class="btn btn-xs btn-outline-danger" @click="removeFinanciero(idx)">
                  <vue-feather type="trash-2" size="14" />
                </button>
              </div>
              <div class="row g-2">
                <div class="col-6 col-md-4">
                  <label class="form-label">Banco</label>
                  <select v-model="fin.bancoId" class="form-select form-select-sm">
                    <option :value="null">— Seleccionar —</option>
                    <option v-for="b in catalogos.bancos" :key="b.id" :value="b.id">{{ b.nombre }}</option>
                  </select>
                </div>
                <div class="col-6 col-md-4">
                  <label class="form-label">Instrumento</label>
                  <select v-model="fin.instrumentoId" class="form-select form-select-sm">
                    <option :value="null">— Seleccionar —</option>
                    <option v-for="i in catalogos.instrumentos" :key="i.id" :value="i.id">{{ i.nombre }}</option>
                  </select>
                </div>
                <div class="col-6 col-md-4">
                  <label class="form-label">Titular</label>
                  <input v-model="fin.titular" type="text" class="form-control form-control-sm" />
                </div>
              </div>
            </div>
          </div>
        </section>

      </div>

      <div class="card-footer d-flex justify-content-end">
        <button type="submit" class="btn btn-primary" :disabled="loading">
          <span v-if="loading" class="spinner-border spinner-border-sm me-1" role="status"></span>
          Guardar
        </button>
      </div>
    </form>
  </div>
</template>

<script>
import api from '@/axios';

const emptyForm = () => ({
  informacionPersonal: {
    nombre: '',
    paterno: '',
    materno: '',
    rfc: '',
    generoId: null,
    estadoCivilId: null,
    estatura: null,
    peso: null,
  },
  informacionLaboral: {
    unidadId: null,
    puesto: '',
    area: '',
    departamento: '',
    referencias: '',
    fechaIngreso: '',
  },
  domicilios: [],
  medios: [],
  informacionFinanciera: [],
});

export default {
  name: 'editContratante',

  data() {
    return {
      form: emptyForm(),
      catalogos: {
        generos: [],
        estadosCiviles: [],
        unidades: [],
        estados: [],
        tiposDomicilio: [],
        tiposMedio: [],
        bancos: [],
        instrumentos: [],
      },
      loading: false,
      error: null,
      successMsg: null,
    };
  },

  mounted() {
    this.loadCatalogos();
    this.loadData();
  },

  methods: {
    async loadCatalogos() {
      const endpoints = [
        ['generos', 'generos'],
        ['estadosCiviles', 'estadosciviles'],
        ['unidades', 'unidades'],
        ['estados', 'estados'],
        ['tiposDomicilio', 'tiposdomicilio'],
        ['tiposMedio', 'tiposmedio'],
        ['bancos', 'bancos'],
        ['instrumentos', 'instrumentos'],
      ];
      await Promise.allSettled(
        endpoints.map(async ([key, endpoint]) => {
          try {
            const res = await api.get(endpoint);
            this.catalogos[key] = Array.isArray(res.data) ? res.data : (res.data?.items ?? []);
          } catch {
            // catálogo no disponible, se deja vacío
          }
        })
      );
    },

    async loadData() {
      const id = this.$route.params.id;
      if (!id) return;
      try {
        this.loading = true;
        this.error = null;
        const res = await api.get(`contratantes/${id}/detalle`);
        this.populateForm(res.data);
      } catch (err) {
        console.error('Error cargando contratante:', err);
        this.error = 'No se pudo cargar el contratante.';
      } finally {
        this.loading = false;
      }
    },

    populateForm(data) {
      const p = data.informacionPersonal || {};
      this.form.informacionPersonal = {
        nombre: p.nombre || '',
        paterno: p.paterno || '',
        materno: p.materno || '',
        rfc: p.rfc || '',
        generoId: p.generoId ?? null,
        estadoCivilId: p.estadoCivilId ?? null,
        estatura: p.estatura ?? null,
        peso: p.peso ?? null,
      };

      const l = data.informacionLaboral || {};
      this.form.informacionLaboral = {
        unidadId: l.unidad?.id ?? l.unidadId ?? null,
        puesto: l.puesto || '',
        area: l.area || '',
        departamento: l.departamento || '',
        referencias: l.referencias || '',
        fechaIngreso: l.fechaIngreso ? l.fechaIngreso.substring(0, 10) : '',
      };

      this.form.domicilios = (data.domicilios || []).map(d => ({
        id: d.id ?? 0,
        tipoDomicilioId: d.tipoDomicilioId ?? null,
        calle: d.calle || '',
        estadoId: d.estadoId ?? null,
        isActive: d.isActive ?? true,
      }));

      this.form.medios = (data.medios || []).map(m => ({
        id: m.id ?? 0,
        tipoMedioId: m.tipoMedioId ?? null,
        descripcion: m.descripcion || '',
        isActive: m.isActive ?? true,
      }));

      this.form.informacionFinanciera = (data.informacionFinanciera || []).map(f => ({
        id: f.id ?? 0,
        bancoId: f.bancoId ?? null,
        instrumentoId: f.instrumentoId ?? null,
        titular: f.titular || '',
      }));
    },

    async save() {
      try {
        this.loading = true;
        this.error = null;
        this.successMsg = null;
        const id = this.$route.params.id;
        await api.put(`contratantes/${id}`, this.form);
        this.successMsg = 'Contratante actualizado correctamente.';
        setTimeout(() => { this.successMsg = null; }, 3000);
      } catch (err) {
        console.error('Error guardando contratante:', err);
        this.error = err.response?.data?.message || 'No se pudo guardar el contratante.';
      } finally {
        this.loading = false;
      }
    },

    addDomicilio() {
      this.form.domicilios.push({ id: 0, tipoDomicilioId: null, calle: '', estadoId: null, isActive: true });
    },
    removeDomicilio(idx) {
      this.form.domicilios.splice(idx, 1);
    },

    addMedio() {
      this.form.medios.push({ id: 0, tipoMedioId: null, descripcion: '', isActive: true });
    },
    removeMedio(idx) {
      this.form.medios.splice(idx, 1);
    },

    addFinanciero() {
      this.form.informacionFinanciera.push({ id: 0, bancoId: null, instrumentoId: null, titular: '' });
    },
    removeFinanciero(idx) {
      this.form.informacionFinanciera.splice(idx, 1);
    },
  },
};
</script>

<style scoped>
.detalle-contratante section {
  padding: 1rem 0;
  border-bottom: 1px solid var(--bs-border-color, #e5e7eb);
}
.detalle-contratante section.last,
.detalle-contratante section:last-child {
  border-bottom: 0;
  padding-bottom: 0;
}
.detalle-contratante section:first-child {
  padding-top: 0;
}
.section-title {
  display: flex;
  align-items: center;
  font-size: 0.8rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.03em;
  color: var(--bs-secondary-color, #6c757d);
  margin-bottom: 0.75rem;
}
.entry-list {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}
.item-card {
  padding: 0.75rem 0.85rem;
  border: 1px solid var(--bs-border-color, #e5e7eb);
  border-radius: 0.375rem;
  background: var(--bs-tertiary-bg, #f8f9fa);
}
.item-card .form-label {
  font-size: 0.72rem;
  margin-bottom: 0.15rem;
}
.btn-xs {
  padding: 0.15rem 0.4rem;
  font-size: 0.75rem;
  line-height: 1.4;
}
</style>
